import { render, staticRenderFns } from "./TargetedRefetchModal.vue?vue&type=template&id=b48b8d7e&"
import script from "./TargetedRefetchModal.vue?vue&type=script&lang=js&"
export * from "./TargetedRefetchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports